import comp from "./LibraryItem";
export default comp;
